import { render, staticRenderFns } from "./UserInformationPanel.vue?vue&type=template&id=16cc6ae6&scoped=true&"
import script from "./UserInformationPanel.vue?vue&type=script&lang=js&"
export * from "./UserInformationPanel.vue?vue&type=script&lang=js&"
import style0 from "./UserInformationPanel.vue?vue&type=style&index=0&id=16cc6ae6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16cc6ae6",
  null
  
)

export default component.exports